import ArbitrationsPage from './ArbitrationsPage.page';

export default ArbitrationsPage;
